module.exports = __webpack_public_path__ + "img/4.89a1f3f4.png";